import makeUserRolesSelector from './makeUserRolesSelector'

export const getCurrentUserId = (state, props) => {
  return state.kanbo.currentUser.id
}

export default makeUserRolesSelector(getCurrentUserId)
